import styled from "styled-components";

export const GithubSection = styled.div`
  margin-top: 32px;
  margin-bottom: 64px;

  img {
    height: 157px;
    margin-right: 32px;

    @media (max-width: 768px) {
      height: auto;
      width: 100%;
    }
  }
`;
